import { Component, Input, OnInit, Output } from '@angular/core';
import { HomeSectionType } from '../../enums/home-section-type.enum';
import { HomeSectionModel } from '../../models/home-section.model';
import { StudentCourseService } from 'src/app/course/services/student-course.service';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { CourseTypeEnum } from 'src/app/course/enums';
import { LanguageService } from 'src/app/services/language.service';
import { Course } from 'src/app/shared/models/course';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { CategoryService } from 'src/app/course/services/category.service';
import { DropDownModel } from 'src/app/@core/models/dropdown.model';

@Component({
  selector: 'app-recorded-courses',
  templateUrl: './recorded-courses.component.html',
  styleUrls: ['./recorded-courses.component.scss'],
})
export class RecordedCoursesComponent implements OnInit {
  @Input() courseTypeSectionsStatus: HomeSectionModel[];
  recordedFilter: FilterModel = new FilterModel(0, 10);
  recordedCourses: Course[] = [];
  isRtl: boolean = true;
  categories: DropDownModel[] = [];
  homeSections = HomeSectionType;

  constructor(
    private studentCourseService: StudentCourseService,
    private languageService: LanguageService,
    private categoryService: CategoryService
  ) {}

  ngOnInit(): void {
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange.subscribe(
      (result: LanguageEnum) => (this.isRtl = result === LanguageEnum.ar)
    );

    this.getCategories();
    this.getCourses();
  }

  getCategories() {
    this.categoryService.getShowInHomeDropDown().subscribe((result: any) => {
      this.categories = result;
    });
  }

  getCourses() {
    this.studentCourseService
      .getPaging(this.recordedFilter, `types=${CourseTypeEnum.Recorded}&forDiploma=false`)
      .subscribe({
        next: (data) => (this.recordedCourses = data.data.slice(0, 4)),
        error: (error: HttpErrorResponse) => console.log(error),
      });
  }

  onChangeCategory(category: number | null): void {
    if (category) this.recordedFilter.parent = category;
    else this.recordedFilter = new FilterModel(0, 10);
    this.getCourses();
  }
}
